<template>
  <!-- 优惠券活动 -->
  <div>
    <div class="wrapper"
         v-if="activeStatus===true">
      <div><img :src="coverImg"
             style="display:block; width:1rem;"></div>
      <div class="formwrap"
           :style="{backgroundImage:'url('+ bgImg +')'}">
        <div class="formbox"
             v-if="couponActiveStatus">
          <div class="formtt">领取礼券</div>
          <div class="inputbox">
            <input type="text"
                   v-model="phone"
                   placeholder="请输入手机号"
                   class="txtinput"
                   maxlength="11">
          </div>
          <div class="inputbox">
            <input type="text"
                   style="float:left;"
                   v-model="code"
                   placeholder="短信验证码"
                   class="txtinput"
                   maxlength="6">
            <span @click="sendCode"
                  :class="['btnsend',{'disabled':sendStatus}]">{{sendStatus? (sendCount+'s后重新获取'):'获取验证码'}}</span>
      <Verify
        @close="boxClose"
        @success="success"
        :mode="'pop'"
        :captchaType="'blockPuzzle'"
        :imgSize="{ width: '330px', height: '155px' }"
        ref="verify"
      ></Verify>
          </div>
          <div class="btnsub"
               @click="draw">提交</div>
        </div>
        <!-- <div class="couplebox">
          <p class="couplett">券码信息</p>
          <p class="couplenum">{{ecode}}</p>
        </div> -->
        <div class="messagebox"
             v-if="successValid">
          <van-icon name="success" />
          <div class="messtext">已成功领取优惠券</div>
        </div>
        <div class="couponcardbox"
             v-for="(item,index) in tableData"
             :key="index">
          <div class="cardLeft">
            <div class="cardTitle">{{item.couponBase.couponName}}</div>
            <div class="cardValid" v-if="item.couponBase.expirationType==0">{{item.couponBase.dayNum}}天内有效</div>
            <div class="cardValid" v-if="item.couponBase.expirationType==1">{{item.couponBase.startTime}}至{{item.couponBase.endTime}}有效</div>
            <div class="cardCondition">
              <span class="cardCondition_tips">限{{getChannelsName(item.extraData.channel || [])}}可用</span>
            </div>
          </div>
          <div class="cardRight">
            <div class="cardAmount">{{item.extraData.promotionAmount}}{{['元','折','枚'][item.couponBase.couponType]}}</div>
            <!-- <div class="cardAmountCondition">满100元可用</div> -->
          </div>
        </div>
        <div class="activityRules">
            <div class="activityRules_title">使用规则</div>
            <div class="activityRules_content" v-html="instructionText"></div>
        </div>
      </div>

    </div>
    <div class="wrapper"
         v-if="activeStatus===false">
      <img :src="emptyPic"
           class="emptyPic">
      <p class="emptyp">{{tips}}</p>
    </div>
  </div>
</template>

<script>
import Verify from '@/components/verifition/Verify'
export default {
  name: "coupon_activity",
  components: { Verify },
  data () {
    return {
      loginFlag: false,
      successValid: false,
      couponActiveStatus: true,
      tips: '',
      emptyPic: require('@a/empty_no.png'),
      activeStatus: '',
      phone: '',
      code: '',
      sendStatus: false,
      sendCount: 60,
      coverImg: '',
      bgImg: '',
      ecodeProductId: '',
      tableData: [],
      instructionText: ''
    }
  },
  created () {
    this.coverImg = this.$route.query.coverImg || ''
    this.bgImg = this.$route.query.bgImg || ''
    this.instructionText = this.$route.query.instructionText || ''
    this.tableData = JSON.parse(this.$route.query.tableData || null) || []
    if (this.$route.query.merchantId && this.$route.query.activityId) {
      let params = {
        merchantId: this.$route.query.merchantId,
        activityId: this.$route.query.activityId
      }
      if (this.$route.query.externalMemberId) {
        params.externalMemberId = this.$route.query.externalMemberId
      }
      if (this.$route.query.externalSource) {
        params.externalSource = this.$route.query.externalSource
      }
      this.API.ecodePage(params).then(res => {
        if (res.status === 200 && res.data.activityType === 3) {
          document.title = res.data.pageData.activityName
          this.activeStatus = true
          this.coverImg = res.data.pageData.coverImg
          this.bgImg = res.data.pageData.bgImg
          this.instructionText = res.data.pageData.instructionText
          this.ecodeProductId = res.data.pageData.ecodeProductId
          this.tableData = (res.data.pageData.couponInfos || []).map(item => {
            let couponBase = {}
            let extraData = {}
            couponBase.couponName = item.couponName || ''
            couponBase.dayNum = item.dayNum || 0
            couponBase.couponType = item.couponType
            couponBase.expirationType = item.expirationType
            couponBase.startTime = item.startTime
            couponBase.endTime = item.endTime
            extraData.channel = item.extraData.channel || []
            extraData.promotionAmount = item.extraData.promotionAmount || 0
            return Object.assign({}, { 'couponBase': couponBase }, { 'extraData': extraData })
          })
        } else {
          this.activeStatus = false
          // if (res.errorCode === '10003') {
          //   this.tips = '没有电子码'
          // }
          // if (res.errorCode === '10008') {
          this.tips = '您来迟了，活动已结束'
          // }
        }
      })
    } else {
      this.activeStatus = true
    }
  },
  mounted () { },
  methods: {
    boxClose (val) {
      val && (this.loginFlag = false)
    },
    success ({ captchaVerification }) {
      // if (this.sendStatus) {
      //   return
      // }
      let timer
      this.API.sendSms({
        merchantId: this.$route.query.merchantId,
        phone: this.phone,
        captchaVerification
      }).then(res => {
        if (res.status === 200) {
          this.sendStatus = true
          this.$toast({ content: '短信验证码已发送' })
          timer = setInterval(() => {
            if (this.sendCount == 0) {
              this.loginFlag = false
              this.sendStatus = false
              this.sendCount = 60
              clearInterval(timer)
            } else {
              this.sendCount = this.sendCount - 1
            }
          }, 1000);
        } else {
          this.loginFlag = false
          this.$toast({ content: res.error })
        }
      }).catch(() => {
        this.loginFlag = false
      })
    },
    getChannelsName (value) {
      const channelList = [
        { label: '微信', value: '0' },
        { label: '一体机', value: '1' },
        { label: '收银台', value: '3' }
      ]
      if (value) {
        return value.map((value) => {
          const result = channelList.filter(item => +item['value'] === +value)
          return result[0] ? result[0]['label'] : ''
        }).join(',')
      }
      return ''
    },
    draw () {
      if (this.phone == '') {
        this.$toast({ content: '请输入您的手机号' })
        return
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$toast({ content: '请输入正确的手机号' })
        return
      }
      if (this.code == '') {
        this.$toast({ content: '请输入短信验证码' })
        return
      }
      let params = {
        merchantId: this.$route.query.merchantId,
        ecodeProductId: this.ecodeProductId,
        phone: this.phone,
        validCode: this.code,
        activityId: this.$route.query.activityId
      }
      if (this.$route.query.externalMemberId) {
        params.externalMemberId = this.$route.query.externalMemberId
      }
      if (this.$route.query.externalSource) {
        params.externalSource = this.$route.query.externalSource
      }
      if (this.$route.query.appId) {
        params.appId = this.$route.query.appId
      }
      this.API.ecodeDraw(params).then(res => {
        if (res.status === 200) {
          this.activeStatus = true
          this.couponActiveStatus = false
          this.successValid = true
          setTimeout(() => { this.successValid = false }, 3000)
          this.coverImg = res.data.coverImg
          this.bgImg = res.data.bgImg
          this.instructionText = res.data.instructionText
        } else {
          this.$toast({ content: res.error })
        }
      })

    },
    sendCode () {
    //   if (this.sendStatus) {
    //     return
    //   }
      if (this.phone == '') {
        this.$toast({ content: '请输入您的手机号' })
        return
      }
      if (!/^1\d{10}$/.test(this.phone)) {
        this.$toast({ content: '请输入正确的手机号' })
        return
      }
      if (this.loginFlag) {
        return
      }
      this.$refs.verify.show()
      this.loginFlag = true
    }
  }
};
</script>
<style>
body {
  background: #f5f7fc;
}
</style>
<style lang="less" scoped>
.wrapper {
  width: 1rem;
}
.formwrap {
  width: 1rem;
  padding: 0 0.024rem 0.15333333333333332rem;
  background-repeat: no-repeat;
  background-size: 1rem auto;
  background-position: 0 bottom;
  padding-bottom: 1.56rem;
}
.formbox {
  background: #fff;
  width: 0.872rem;
  height: 0.768rem;
  border-radius: 0.042666666666666665rem;
  margin: 0 auto;
}
.rulebox {
  background: #fff;
  width: 0.872rem;
  border-radius: 0.042666666666666665rem;
  margin-top: 0.032rem;
}
.rulein {
  padding: 0.08rem 0.064rem 0.10666666666666667rem;
}
.rulett {
  font-weight: 500;
  font-size: 0.053333rem;
  color: #333333;
  padding-bottom: 0.05rem;
  border-bottom: 1px solid #e8e8e8;
}
.rulenote {
  p {
    font-size: 0.037333rem;
    padding-top: 0.04rem;
    line-height: 1.5;
  }
}
.couplebox {
  background: #fff;
  width: 0.872rem;
  height: 0.42rem;
  border-radius: 0.042666666666666665rem;
  // margin-top: 0.032rem;
  margin: 0.032rem auto 0;
}
.couplett,
.formtt {
  font-weight: 500;
  width: 0.744rem;
  color: #333333;
  border-bottom: 1px solid #e8e8e8;
  padding-top: 0.08rem;
  padding-bottom: 0.05rem;
  margin-left: 0.064rem;
  font-size: 0.053333rem;
}
.couplenum {
  color: #333333;
  padding-top: 0.07rem;
  margin-left: 0.064rem;
  font-size: 0.05rem;
}
.inputbox {
  height: 0.148rem;
  overflow: hidden;
  border-bottom: 1px solid #e8e8e8;
  margin-left: 0.064rem;
  width: 0.744rem;
}
.txtinput {
  line-height: 0.148rem;
  width: 0.4rem;
  height: 0.148rem;
  background: none;
  border: none;
  color: #333333;
}
.btnsend {
  width: 0.293333rem;
  margin-top: 0.025333rem;
  float: right;
  text-align: center;
  line-height: 0.096rem;
  height: 0.096rem;
  background: linear-gradient(319deg, #ffbc26 0%, #ffd800 100%);
  border-radius: 0.021333rem;
}
.btnsend.disabled {
  color: #fff;
  background: #ccc;
}
.btnsub {
  width: 0.490667rem;
  height: 0.106667rem;
  line-height: 0.106667rem;
  margin: 0.073333rem auto 0;
  background: linear-gradient(319deg, #ffbc26 0%, #ffd800 100%);
  border-radius: 0.021333rem;
  text-align: center;
  font-size: 0.042667rem;
}
.emptyPic {
  width: 0.5rem;
  height: 0.5rem;
  margin: 0.5rem 0.25rem 0;
}
.emptyp {
  text-align: center;
  font-size: 0.034667rem;
  color: #a2a3b8;
  padding-top: 0.094667rem;
}
</style>

<style lang="postcss" scoped>
.activityRules {
  width: 340px;
  /* height: 115px; */
  margin: 12px auto 0;
  padding: 25px 10px;
  background: #fff;
  border-radius: 15px;
}
.activityRules_title {
  padding: 0 5px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d1a17;
  line-height: 22px;
  text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04);
}
.activityRules_content {
  white-space: pre-wrap;
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  /* color: #1d1a17; */
  word-break: break-all
}
.couponcardbox {
  position: relative;
  display: flex;
  width: 340px;
  height: 115px;
  margin: 12px auto 0;
}
.couponcardbox::before,
.couponcardbox::after {
  width: 20px;
  height: 10px;
  content: "";
  position: absolute;
  display: block;
  background: #f5f8f8;
  left: 212px;
}
.couponcardbox::before {
  border-radius: 0 0 20px 20px;
  /* top: -8px; */
}
.couponcardbox::after {
  border-radius: 20px 20px 0 0;
  top: 105px;
}
.cardLeft {
  padding: 16px 12px;
  width: 222px;
  height: 115px;
  background: #ffffff;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.04);
  border-radius: 12px 0 0 12px;
}
.cardTitle {
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1d1a17;
  line-height: 22px;
  text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04);
}
.cardValid {
  margin-top: 5px;
  height: 17px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1d1a17;
  line-height: 17px;
  text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04);
}
.cardCondition {
  margin-top: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff8700;
  text-shadow: 0px 10px 20px rgba(0, 0, 0, 0.04);
}
.cardCondition_tips {
  padding: 0 5px;
  width: 100%;
  height: 16px;
  line-height: 16px;
  font-size: 10px;
  background: #fff5ea;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
}
.cardRight {
  width: 118px;
  height: 115px;
  background: linear-gradient(323deg, #ff9d20 0%, #ffdb17 100%);
  text-align: center;
  border-radius: 0 12px 12px 0;
}
.cardAmount {
  /* margin-top: 30.5px; */
  height: 28px;
  line-height: 110px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  /* line-height: 28px; */
}
.cardAmountCondition {
  margin-top: 10px;
  height: 22px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
}

.messagebox {
  margin: 12px auto 0;
  display: flex;
  align-items: center;
  width: 327px;
  height: 92px;
  line-height: 92px;
  background: #ffffff;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
}
.van-icon-success::before {
  width: 29px;
  height: 29px;
  background: #07c160;
  line-height: 29px;
  text-align: center;
  border-radius: 50%;
  color: #ffffff;
  font-size: 18px;
}
.messtext {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}
.van-icon {
  margin: 0 14.9px 0 22.9px;
}
</style>
